import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import initAnimationController from "./rbx-animation-controller";
import LogoRBF from "../../../assets/logos/rbf-logo.svg?url";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const RBXAnimation = ({
  className,
  scalingFactor,
  dashColor,
  dashSize,
  dashGap,
  dashSpeedFactor,
  animationSpeedFactor,
  dashScale,
  animationEffectSize,
}) => {
  const animationRef = useRef();
  const { simpleDesign } = useAccessibilityContext();
  const [webglFailed, setWebglFailed] = useState(false);

  useEffect(() => {
    if (!simpleDesign) {
      const renderer = initAnimationController(animationRef.current, {
        scalingFactor,
        dashColor,
        dashSize,
        dashGap,
        dashSpeedFactor,
        animationSpeedFactor,
        dashScale,
        animationEffectSize,
      });

      if (!renderer) {
        setWebglFailed(true);
        return;
      }

      return () => {
        renderer.dispose();
      }
    }
  }, [animationRef]);

  if (simpleDesign || webglFailed) {
    return <div className="loading-animation"><img src={LogoRBF} className="logo simple" alt={"Logo RBF"} /></div>;
  } else {
    return <div className={className} ref={animationRef}></div>;
  }
};

RBXAnimation.propTypes = {
  className: PropTypes.string,
  dashColor: PropTypes.string,
  dashSize: PropTypes.number,
  dashGap: PropTypes.number,
  dashSpeedFactor: PropTypes.number,
  animationSpeedFactor: PropTypes.number,
  dashScale: PropTypes.number,
  animationEffectSize: PropTypes.number,
};

export default RBXAnimation;
